/* eslint-disable  no-unused-vars, @typescript-eslint/no-unused-vars */
import { ActionType } from 'typesafe-actions';
import { createDataFetchActions } from '../dataFetching/generators';
import { PriceFormatConfigOptions } from '../products/types';

export const homepageActions = createDataFetchActions(
    '@HOME_PAGE',
    ({ apiService }) => (_: PriceFormatConfigOptions) => apiService.shopApi.getHomePageCmsData(),
    _ => '@HOME_PAGE',
    priceFormatOptions => priceFormatOptions
);

export type HomePageActions = ActionType<typeof homepageActions.actions>;
export const fetchHomePageCmsDataIfNeeded = homepageActions.thunk;
